import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import useSearchParams from 'hooks/useSearchParams';
import { useUpdatePlaylistContent } from 'actions/playlists';
import { formatContentManagerPayload } from '../Editor/utils/formatContentManagerPayload';
import { CONTENT_SELECTION_SEARCH_PARAM } from '../Editor/useContentManagerSelection';
import EditorSaveStatus from 'components/EditorSaveStatus';
import StickyBox from 'components/StickyBox';
import TooltipButton from 'components/TooltipButton';
import Flex from 'components/Flex';
import Card from 'components/Card';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StickyFooter(_ref) {
  var reducerState = _ref.reducerState,
    hasPlaylistChanges = _ref.hasPlaylistChanges,
    initialPlaylistData = _ref.initialPlaylistData,
    routes = _ref.routes;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _reducerState = _slicedToArray(reducerState, 3),
    content = _reducerState[0].content,
    dispatch = _reducerState[1],
    undoHistory = _reducerState[2];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    setSearchParams = _useSearchParams2[1];
  var _useUpdatePlaylistCon = useUpdatePlaylistContent({
      playlistId: initialPlaylistData.id
    }),
    updatePlaylistContent = _useUpdatePlaylistCon.updatePlaylistContent,
    isSaving = _useUpdatePlaylistCon.isPending;
  function saveContentChanges() {
    return _saveContentChanges.apply(this, arguments);
  }
  function _saveContentChanges() {
    _saveContentChanges = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var initialContentIds, patchPayload;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Get the ids of the content initially in the playlist (before any changes)
            initialContentIds = initialPlaylistData.content.map(function (_ref2) {
              var id = _ref2.id;
              return id;
            });
            patchPayload = formatContentManagerPayload({
              content: content,
              initialContentIds: initialContentIds
            });
            _context.next = 1;
            return updatePlaylistContent(patchPayload);
          case 1:
            // Clear selected items
            setSearchParams(_defineProperty({}, CONTENT_SELECTION_SEARCH_PARAM, undefined));
            // Reset content manager state
            dispatch({
              type: 'RESET'
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _saveContentChanges.apply(this, arguments);
  }
  return /*#__PURE__*/_jsx(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m",
    children: /*#__PURE__*/_jsx(Card, {
      px: "m",
      py: "s",
      children: /*#__PURE__*/_jsx(EditorSaveStatus, {
        onSave: saveContentChanges,
        hasUnsavedChanges: hasPlaylistChanges,
        isSaving: isSaving,
        noUnsavedChangesText: t('state_no_changes_since_last_save'),
        stateOptions: /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(TooltipButton, {
            iconOnly: true,
            icon: "undo",
            variant: "transparent",
            isDisabled: undoHistory.past.length === 0,
            onClick: function onClick() {
              return dispatch({
                type: 'UNDO'
              });
            },
            children: t('actions_undo')
          }), /*#__PURE__*/_jsx(TooltipButton, {
            iconOnly: true,
            icon: "redo",
            variant: "transparent",
            isDisabled: undoHistory.future.length === 0,
            onClick: function onClick() {
              return dispatch({
                type: 'REDO'
              });
            },
            children: t('actions_redo')
          })]
        }),
        previewOptions: {
          previewPath: generatePath(routes.preview, {
            playlistId: initialPlaylistData.id
          }),
          exitPath: generatePath(routes.root, {
            playlistId: initialPlaylistData.id
          })
        },
        justifyContent: ['space-between', 'space-evenly'],
        breakpoints: "xxs"
      })
    })
  });
}